export default "__VITE_ASSET__BcqPjvLX__"